import { MarketDataService } from './../market-data/market-data.service';
import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppConfig } from '../app.config';
import { CurrencyUtil, buildFXQuote, QuoteTenor, buildMMQuote, Quote, buildConventionalFXQuote } from '@liquitics/transaction';

@Component({
    selector: 'app-market-data',
    templateUrl: './market-data.component.html',
    styleUrls: ['./market-data.component.css']
})
export class MarketDataComponent implements OnInit, OnDestroy {
    POLLING_INTERVAL = 60000;
    globaltenoredData: any = {};
    tableData: any = [];
    baseCurrency: string;
    currencies: string[];
    amountCols: any[];


    constructor(private marketDataService: MarketDataService, private appConfig: AppConfig) {
        this.baseCurrency = this.appConfig.activeUserProfile.getBaseCurrency();
        this.currencies = this.appConfig.activeUserProfile.getCurrencies();
        this.amountCols = [
            { field: 'fxRate', header: 'FX' },
            { field: 'mmRate', header: 'Rate' }
        ];
        const interval = setInterval(() => {
            this.refreshMarketDataRows();
        }, this.POLLING_INTERVAL);
    }

    refreshMarketDataRows() {
        this.tableData = [];
        const tenors = [QuoteTenor.T_1D, QuoteTenor.T_2D, QuoteTenor.T_1W, QuoteTenor.T_2W,
        QuoteTenor.T_3W, QuoteTenor.T_1M, QuoteTenor.T_2M, QuoteTenor.T_3M, QuoteTenor.T_6M];

        this.tableData = tenors.map((tenor: string) => {
            const tenorRow = {};
            this.currencies.forEach((currency: string) => {
                tenorRow[currency + '_tenor'] = tenor;
                const fxQuoteNames = [buildConventionalFXQuote(this.baseCurrency, currency, tenor, '').name];
                this.marketDataService.registerQuotes(fxQuoteNames);
                const fxRate = this.marketDataService.getSingleRate(fxQuoteNames[0], 0.0);
                tenorRow[currency + '_fxRate'] = fxRate;
                const mmQuoteNames = [buildMMQuote(currency, tenor, '').name]
                this.marketDataService.registerQuotes(mmQuoteNames);
                const mmRate = this.marketDataService.getSingleRate(mmQuoteNames[0], 0.0);
                tenorRow[currency + '_mmRate'] = mmRate;
            });
            return tenorRow;
        });
    }

    necessaryColumns(currency: string) {
        if (this.baseCurrency === currency) {
            return this.amountCols.filter(col => col.header !== 'FX').map(col => col);
        } else {
            return this.amountCols.map(col => col);
        }
    }

    ngOnInit() {
        // this.dataStreamDisposable = this.dataStream$.subscribe({next: observable => {
        //     observable.subscribe({next: (data: MarketDataRow[]) => {
        //         this.tableData = [];
        //         this.currencies.map(currency => {
        //             this.globaltenoredData = data
        //                 .filter(entry => {
        //                     return (entry.currency.toUpperCase() === currency.toUpperCase());
        //                 })
        //                 .map(entry => {
        //                     const tenorRow = {};
        //                     tenorRow['tenor'] = entry.tenor;
        //                     Object.keys(entry).map((key, index) => {
        //                         tenorRow[currency + '_' + key] = entry[key];
        //                     });
        //                     return tenorRow;
        //                 }).reduce(function (tenoredData, row) {
        //                     let aggRow = tenoredData[row['tenor']];
        //                     if (!aggRow) {
        //                         aggRow = { tenor: row['tenor'] };
        //                         tenoredData[row['tenor']] = aggRow;
        //                     }
        //                     Object.keys(row).map((key, index) => {
        //                         aggRow[key] = row[key];
        //                     });
        //                     return tenoredData;
        //                 }, this.globaltenoredData);
        //             const newTableData = Object.keys(this.globaltenoredData).map(key => {
        //                 return this.globaltenoredData[key];
        //             });
        //             this.tableData = newTableData;
        //         }
        //         );
        //     });
        // });
    }

    ngOnDestroy() {
    }
    flagIconClass(currency) {
        return 'flag-icon flag-icon-' + this.flagCodeForCurrency(currency);
    }
    flagCodeForCurrency(currency) {
        if (currency === 'usd') {
            return 'us';
        }
        if (currency === 'eur') {
            return 'eu';
        }
        return '';
    }
}
